// useDragScroll.ts
import { RefObject, useEffect } from "react";

export default function useDragScroll(ref: RefObject<HTMLElement | null>) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let startY = 0;
    let startTop = 0;

    const down = (e: MouseEvent) => {
      if (e.button !== 0 || (e.target as HTMLElement).closest("a,button")) return;
      startY = e.clientY;
      startTop = el.scrollTop;

      el.style.cursor = "grabbing";
      el.style.userSelect = "none";

      document.addEventListener("mousemove", move);
      document.addEventListener("mouseup", up);
    };

    const move = (e: MouseEvent) => {
      const dy = e.clientY - startY;
      el.scrollTop = startTop - dy;
    };

    const up = () => {
      el.style.cursor = "";
      el.style.removeProperty("user-select");
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", up);
    };

    el.addEventListener("mousedown", down);
    return () => el.removeEventListener("mousedown", down);
  }, [ref]);
}
